import type { NonNullableFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import {
  type ControlInterface,
  dateValidator,
  enumValidator,
  getTomorrowDate,
  getXYearInTheFutureDate,
  maxDateValidator,
  minDateValidator,
} from '@comparit/core';
import { Laufzeit, type Step2FormInput, Zahlungsweise } from '../../../interfaces';

export class Step2Form {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: Step2FormInput | null
  ) {}

  ctrls: ControlInterface<Step2FormInput> = {
    // The Sparte takes a Vertragsbeginn from tomorrow up to a year out, so that is also the default.
    vertragsbeginn: this.fb.control<string>(
      this.defaultValue?.vertragsbeginn ?? getTomorrowDate().toISOString(),
      [
        dateValidator(),
        Validators.required,
        minDateValidator(getTomorrowDate()),
        maxDateValidator(getXYearInTheFutureDate(1)),
      ]
    ),
    // enumValidator rather than required alone: both are seeded with a valid default and the
    // selects cannot produce anything else, so the only way they go bad is a value restored from
    // storage that the Sparte no longer offers.
    laufzeit: this.fb.control<Laufzeit>(this.defaultValue?.laufzeit ?? Laufzeit.L3Jahre, [
      Validators.required,
      enumValidator(Laufzeit),
    ]),
    zahlungsweise: this.fb.control<Zahlungsweise>(
      this.defaultValue?.zahlungsweise ?? Zahlungsweise.Jaehrlich,
      [Validators.required, enumValidator(Zahlungsweise)]
    ),
  };

  public fg = this.fb.group(this.ctrls);
}
